import { createReducers, createActions, request } from '../../../utils/';
import { combineReducers } from 'redux';
import Urls from '../../../../config/index';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';
const { MonitorUrl } = Urls;

const path = name => `app/pages/monitor/localResourceRate/${name}`;
const models = {
    rateList: {
        data: [],
        handlers: {
            setrateList(state, action) {
                return action.payload;
            },
        }
    },
    
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {
           // beginTime: moment().format('YYYY-MM-DD'),
            //endTime: moment().format('YYYY-MM-DD'),
        },
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isUpdateShow: false,
            isSendCommend: false,
            onSelectTab: 1,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().localResourceRate;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};


export const asyncGetEvs = () => {
    return async (dispatch, getState) => {
        try {
            //console.log("搜索条件 ",formatGetParams(getState))
            let result = await request(MonitorUrl.localResourceRate, 'POST', formatGetParams(getState));

            result.map(item => {
                                 item.key = item.index;
                                return item;
                            });
           
            dispatch(actions.setrateList(result));

        } catch (e) {
            throw e;
        }
    };
};






// WEBPACK FOOTER //
// ./pages/monitor/localResourceRate/reducers.js